<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-03 20:00:12
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-07-21 23:58:31
 * @Description: file content
 -->

<template>
  <div class="container">
    <!-- <Tabbar13></Tabbar13> -->
    <div :class="[{ loaded: showAnimate }]">
      <loading></loading>
    </div>
    <div class="tabHome" v-if="showAnimate">
      <!-- 轮播 -->
      <div class="swiper-wrap">
        <swiperVrVideoImage
          v-if="
            pageInfo &&
              ((pageInfo.Extinfo.video && pageInfo.Extinfo.video.length > 0) ||
                (pageInfo.Extinfo.samplePlate &&
                  pageInfo.Extinfo.samplePlate.length > 0) ||
                (pageInfo.Extinfo.envImages &&
                  pageInfo.Extinfo.envImages.length > 0))
          "
        ></swiperVrVideoImage>
      </div>
      <!-- 个人信息 -->
      <div class="myinfo" v-if="cardUserInfo">
        <div class="info1-wrap">
          <div class="avatar-wrap">
            <img
              class="img-avatar"
              :src="cardUserInfo.ui_headimg || cardUserInfo.headimgurl"
              alt=""
            />
          </div>
          <div class="info1-right">
            <div class="audio-wrap" @click="clickAudio">
              <span>音频</span>
              <img
                class="icon-audio"
                :src="baseUrl + 'vcard3/icon-audio.png'"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="info2-wrap">
          <div class="info2-name">{{ cardUserInfo.ui_name }}</div>
          <div class="info2-right" @click="clickCall">
            <img
              class="icon-tel"
              :src="baseUrl + 'vcard3/icon-tel.png'"
              alt=""
            />
            <span class="info2-tel">{{
              cardUserInfo.ui_mobile || cardUserInfo.mobile
            }}</span>
          </div>
        </div>

        <div class="info3-wrap" v-if="cardUserInfo.ui_personalprofile">
          {{ cardUserInfo.ui_personalprofile }}
        </div>
        <div class="info3-wrap" v-if="!cardUserInfo.ui_personalprofile">
          中海·映山湖，坐拥金融CBD东500m核心地段，占据绝版生态资源，匠造林城奢宅，致敬城市顶豪
        </div>
      </div>

      <div class="btninfo-wrap">
        <div class="btn-item" @click="clickChat">
          <img class="btn-img" :src="baseUrl + 'vcard3/icon1.png'" alt="" />
          <div class="btn-name">在线咨询</div>
        </div>
        <div class="btn-item" @click="clickCall">
          <img class="btn-img" :src="baseUrl + 'vcard3/icon2.png'" alt="" />
          <div class="btn-name">一键致电</div>
        </div>
        <div class="btn-item" @click="clickAddWeChat">
          <img class="btn-img" :src="baseUrl + 'vcard3/icon3.png'" alt="" />
          <div class="btn-name">添加微信</div>
        </div>
        <div class="btn-item" @click="clickAddress">
          <img class="btn-img" :src="baseUrl + 'vcard3/icon4.png'" alt="" />
          <div class="btn-name">一键导航</div>
        </div>
        <div class="btn-item" @click="clickFollow">
          <img class="btn-img" :src="baseUrl + 'vcard3/icon5.png'" alt="" />
          <div class="btn-name">关注官微</div>
        </div>
      </div>

      <div class="video-wrap">
        <div class="nav-container">
          <div class="nav-wrap">
            <div
              @click="clickMenu(1)"
              :class="[currentType == 1 ? 'active' : 'unactive']"
            >
              官方说房
            </div>
            <div
              @click="clickMenu(2)"
              :class="[currentType == 2 ? 'active' : 'unactive']"
            >
              听我说房
            </div>
          </div>
          <div class="check-all" @click="clickCheckAll">
            查看全部
            <div class="arrow"></div>
          </div>
        </div>
        <div class="nav-content">
          <div
            @click="clickVideo(item)"
            class="item-wrap"
            v-for="(item, index) in videoList"
            :key="index"
          >
            <img
              :class="[
                { 'cover-img': true },
                { 'cover-img2': !item.showTitle }
              ]"
              :src="item.main_img"
              alt=""
            />
            <div class="video-title" v-if="item.showTitle">
              {{ item.title }}
            </div>
            <!-- <div
              class="item-video"
              :style="{ backgroundImage: 'url(' + item.main_img + ')' }"
            >
              <div class="video-title">{{ item.title }}</div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="bottom-logo-wrap" @click="clickStatus">
        <img class="img-logo" :src="baseUrl + 'vcard3/bg-logo.png'" alt="" />
        <div class="pro-wrap">
          <span>项目近况</span>
          <img
            class="pro-arrow"
            :src="baseUrl + 'vcard3/pro-arrow.png'"
            alt=""
          />
        </div>
      </div>

      <HdkShareGuide
        v-if="isShowHdkShareGuide"
        v-on:close="closeHdkShareGuide"
      ></HdkShareGuide>
      <ShowImg2
        v-if="showImg2.isShow"
        :my="showImg2"
        v-on:close="showImg2.isShow = false"
      ></ShowImg2>

      <Tabbar12 :seleIndex="0"></Tabbar12>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
import request from "@/utils/request";
import global_ from "../../../../global.config";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
import "video.js/dist/video-js.css";
import { videoList } from "../config";
const ShowImg2 = () => import("@/components/showimg2.vue");
// const BtnBackHome = () => import("@/components/btn_backhome.vue");
const BtnForward = () => import("./BtnForward");
const HdkShareGuide = () => import("@/components/hdk-share_guide.vue");
const Tabbar12 = () => import("@/components/tabbar12");
// const Tabbar13 = () => import("@/components/tabbar13");
// const BaseBanner = () => import("./BaseBanner");
const swiperVrVideoImage = () => import("./swiper_vr_video_img2");
const loading = () => import("./loading");

export default {
  components: {
    ShowImg2,
    // BtnBackHome,
    BtnForward,
    HdkShareGuide,
    Tabbar12,
    // BaseBanner,
    swiperVrVideoImage,
    loading
  },
  props: {},
  data() {
    return {
      projectList: [],
      // address: "",
      gps: null,
      // buildingName: "",
      // title1: "",
      // title2: "",
      baseUrl: "https://assets.rurushishi.com/yq-rs-make/",
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      cardUserInfo: null, //用户名片信息
      currentType: 1, //当前tab类型
      videoAllList: null, //所有视频
      videoList: [], //当前视频列表
      isShowHdkShareGuide: false, //是否显示分享弹框
      showAnimate: false, //是否显示动画
      //获取项目信息
      pcConfig: {
        callBtn: null, //致电 btns type 8
        navBtn: null, // 导航 btns type 9
        askBtn: null, // 咨询 btns type 10
        btns: [], //自定义按钮
        card: null //用户名片信息
      },
      uuid: "", //前端生成的唯一id
      cookieKeys: {
        cardid: "usercard2_cardid",
        uuid: "usercard2_uuid",
        masteropenid: "usercard2_masteropenid",
        projectid: "usercard2_projectid"
      },
      cookieDuration: new Date(new Date().getTime() + 60 * 1000 * 10),
      audio: {
        sound: new Audio(
          "http://assets.rurushishi.com/activies/online/caract6/1.mp3"
        )
      }
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  methods: {
    clickStatus() {
      window.location.href =
        "https://mp.weixin.qq.com/s/rCJnGzjIJFbJjpvf4EqIvQ";
      // this.$router.push(
      //   `/vcard3/status?entry=${this.$route.query.entry}&id=${
      //     this.$route.query.id
      //   }&psn=${this.$route.query.psn}&saleropenid=${
      //     this.$route.query.saleropenid
      //   }&backhome=home&t9id=${this.$route.query.t9id}&t9psn=${
      //     this.$route.query.t9psn
      //   }`
      // );
    },
    clickAddress() {
      if (this.isInMiniProgram && this.gps) {
        wxsdk.wx.openLocation({
          latitude: parseFloat(this.gps.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.gps.lng), // 经度，浮点数，范围为180 ~ -180。
          name: this.buildingName, // 位置名
          address: this.address, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
        });
      } else {
        util.openUrl(
          `http://uri.amap.com/marker?position=${this.gps.lng},${
            this.gps.lat
          }&name=${this.buildingName}`
        );
      }
    },
    clickAudio() {
      // if (Vue.prototype.$isPlayAudio == 1 || Vue.prototype.$isPlayAudio == 2) {
      //   this.audio.sound.pause();
      //   Vue.prototype.$isPlayAudio = 0;
      // } else {
      //   this.audio.sound.play();
      //   Vue.prototype.$isPlayAudio = 1;
      // }
      if (Vue.prototype.$audio.paused) {
        //暂停中
        Vue.prototype.$audio.play();
      } else {
        //播放中
        Vue.prototype.$audio.pause();
      }
    },
    //点击关注官微
    clickFollow() {
      this.showImg2 = {
        isShow: true,
        url: `${this.baseUrl}vcard3/gw.jpeg`,
        width: "50%",
        intro: `扫码，关注官微！`
      };
    },
    //点击返回按钮
    clcickBack() {
      window.history.go(-1);
    },
    //点击电话
    clickCall() {
      util.makePhoneCall(
        this.cardUserInfo.ui_mobile || this.cardUserInfo.mobile
      );
      console.log("this.pcConfig", this.pcConfig);
      if (this.pcConfig.callBtn && this.pcConfig.callBtn.id) {
        this.saveBtnClick(this.pcConfig.callBtn.id);
      }
    },
    //点击微信
    clickAddWeChat() {
      if (this.cardUserInfo) {
        if (!this.isInMiniProgram && this.cardUserInfo.wxqr) {
          // h5环境下有二维码，弹出二维码
          this.showImg2 = {
            isShow: true,
            url: this.cardUserInfo.wxqr,
            width: "50%",
            intro: `扫码，添加${this.cardUserInfo.ui_name}的微信！`
          };
        } else if (this.cardUserInfo.ui_weixin) {
          util.messageBox(`我的微信号是：${this.cardUserInfo.ui_weixin}`);
        } else {
          util.messageBox("亲，您可以用电话联系我");
        }
      } else {
        util.messageBox("亲，您可以用电话联系我");
      }
    },
    clickAddContact() {
      util.messageBox("请长按复制我的手机号：" + this.cardUserInfo.ui_mobile);
    },
    //切换官方说房，听我说房
    clickMenu(type) {
      if (this.currentType != type) {
        this.currentType = type;
      }
      if (this.currentType == 1) {
        this.videoList = this.videoAllList.gfsf;
      } else if (this.currentType == 2) {
        this.videoList = this.videoAllList.twsf;
      }
    },
    //打开引导
    clickShare() {
      // 不管在小程序还是H5分享都改成线框指引
      this.isShowHdkShareGuide = true;
    },
    //关闭引导
    closeHdkShareGuide() {
      this.isShowHdkShareGuide = false;
    },
    //点击在线留言
    clickChat() {
      util.openShqcWebChat2(
        this.cardUserInfo.openid,
        this.cardUserInfo.ui_name || this.cardUserInfo.name
      );
      if (this.pcConfig.askBtn && this.pcConfig.askBtn.id) {
        this.saveBtnClick(this.pcConfig.askBtn.id);
      }
    },
    //点击视频
    clickVideo(item) {
      this.$router.push(
        `/vcard3/video?videoId=${item.id}&entry=${this.$route.query.entry}&id=${
          this.$route.query.id
        }&psn=${this.$route.query.psn}&saleropenid=${
          this.$route.query.saleropenid
        }&backhome=home&t9id=${this.$route.query.t9id}&t9psn=${
          this.$route.query.t9psn
        }`
      );
    },
    //查看全部
    clickCheckAll() {
      this.$router.push(
        `/vcard3/videoList?type=${this.currentType}&entry=${
          this.$route.query.entry
        }&id=${this.$route.query.id}&psn=${this.$route.query.psn}&saleropenid=${
          this.$route.query.saleropenid
        }&backhome=home&t9id=${this.$route.query.t9id}&t9psn=${
          this.$route.query.t9psn
        }`
      );
    },
    //设置开屏动画
    setAnimate() {
      setTimeout(() => {
        this.showAnimate = true;
      }, 800);
    },
    //初始化视频
    initVideoList() {
      this.currentType = 1;
      this.videoAllList = videoList;
      this.videoList = this.videoAllList.gfsf;
    },
    //获取用户信息设置分享
    getUserInfoAndeShare() {
      let saleropenid = this.$route.query.saleropenid;
      if (this.global.isLoc && !saleropenid) {
        saleropenid = this.$openid;
      }

      comreq.fansInfo(saleropenid).then(fansInfo => {
        console.log("fansInfo", fansInfo);
        this.cardUserInfo = fansInfo;
        this.selectCardByProjectid(saleropenid, fansInfo.projectid);
      });

      comreq.displaySalerProjectPages(saleropenid).then(data => {
        if (data && data.list && data.list.length > 0) {
          data.list = data.list.map(item => {
            if (item.extinfo) {
              item.extinfo = JSON.parse(item.extinfo);
              if (item.extinfo.advantage) {
                item.extinfo.advantage = item.extinfo.advantage.split(",");
              }
            }
            return item;
          });
          if (this.global.isLoc) {
            // data.list = data.list.concat(data.list);
            // data.list = data.list.concat(data.list);
          }
          this.address = data.list[0].extinfo.address;
          this.buildingName = data.list[0].extinfo.buildingName;
          this.gps = {
            lng: data.list[0].extinfo.lng,
            lat: data.list[0].extinfo.lat
          };
          this.projectList = data.list;
        }
        console.log("推荐项目", JSON.parse(JSON.stringify(data)));
      });

      util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
        comreq.getUserInfoAndFansInfo(saleropenid).then(data => {
          this.cardUserInfo2 = data;
          // console.log("销售信息", JSON.parse(JSON.stringify(data)));

          this.cardUserInfo2.ui.name
            ? (document.title = `中海·映山湖-${
                this.cardUserInfo2.ui.name
              }的电子名片`)
            : "";
          util.setFoundShareCustomPageName(
            `我是${this.cardUserInfo2.ui.name}，欢迎您随时联系`,
            `手机号：${this.cardUserInfo2.ui.mobile} ${
              this.cardUserInfo2.ui.wechatno
                ? "微信号：" + this.cardUserInfo2.ui.wechatno
                : ""
            }`,
            this.pageInfo,
            this.shareSpreadInfo,
            false,
            `&entry=zxslzx&t9id=${this.$route.query.t9id}&t9psn=${
              this.$route.query.t9psn
            }&saleropenid=${saleropenid}&backhome=home`,
            this.cardUserInfo2.ui.headimg,
            "vcard3/home"
          );
        });
      });
    },
    // 获取项目信息
    selectCardByProjectid(saleropenid, projectid) {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/getElectronicCard",
            requestParam: {
              projectid: parseInt(projectid),
              state: 1,
              masteropenid: saleropenid
            }
          })
          .then(function(response) {
            if (response.obj) {
              var data = response.obj;
              that.pcConfig.card = data;
              console.log("获取项目信息", data);
              // that.saveCardLog();
              // setInterval(() => {
              //   that.saveCardLog();
              // }, 5000);

              if (data.btns) {
                data.btns.forEach(function(e) {
                  if (e.type == 9) {
                    that.pcConfig.callBtn = e;
                  } else if (e.type == 10) {
                    that.pcConfig.navBtn = e;
                  } else if (e.type == 11) {
                    that.pcConfig.askBtn = e;
                  } else {
                    that.pcConfig.btns.push(e);
                  }
                });
              }
            }
          });
      });
    },

    saveCardLog(imageid = "", btnid = "") {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveCardLog",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                uuid: that.uuid, //前端生成的唯一标识
                masteropenid: that.cardUserInfo.openid, //当前电子名片所属人的openid
                imageid: imageid, //如果是浏览的户型图详情，需要提交户型图的id
                btnid: btnid, //功能按钮的id
                referenceopenid: Cookies.get("openid"),
                // referenceopenid: that.$route.query.saleropenid,
                projectid: that.pcConfig.card.projectid
              }
            }
          })
          .then(function(data) {});
      });
    },
    saveBtnClick(btnid = "") {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveBtnClick",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                masteropenid: that.cardUserInfo.openid, //当前电子名片所属人的openid
                uuid: that.uuid, //前端生成的唯一标识
                btnid: btnid //功能按钮的id
              }
            }
          })
          .then(function(response) {
            if (response.obj) {
              // var data = response.obj;
            }
          });
      });
    },

    setUuid: function() {
      var uuid = Cookies.get("usercard2_uuid");
      if (uuid) {
        this.uuid = uuid;
      } else {
        this.uuid = util.getGuid();
        Cookies.set(this.cookieKeys.uuid, this.uuid, {
          expires: this.cookieDuration
        });
      }
    }
  },
  created() {
    this.setUuid();
    this.setAnimate(); //设置开屏动画
    this.initVideoList(); //初始化视频列表
    this.getUserInfoAndeShare(); //获取用户信息设置分享
    // let url = `${location.protocol}//${location.host}/h5/home?saleropenid=${
    //   this.$openid
    // }`;
    // if (!this.isInMiniProgram || util.checkIsHaveOldMp()) {
    //   // 非小程序环境下加上back按钮
    //   url = util.addUrlParamFromObj(url, {
    //     backhome: "back"
    //   });
    // }
    // util.openYqRsMakeLink(url);
  },
  mounted() {
    // console.log("kkkkkkkkkk");
    // // Vue.prototype.$isPlayAudio = 0;
    // let isPlayAudio = Vue.prototype.$isPlayAudio;
    // if (typeof isPlayAudio == "undefined") {
    //   Vue.prototype.$isPlayAudio = 2;
    //   Vue.prototype.$audio = new Audio(
    //     "http://assets.rurushishi.com/activies/online/caract6/1.mp3"
    //   );
    // }
    // // console.log("isPlayAudio----", isPlayAudio);
    // if (Vue.prototype.$isPlayAudio == 2) {
    //   wx.ready(() => {
    //     this.audio.sound.play();
    //   });
    //   Vue.prototype.$isPlayAudio = 2;
    // }
  }
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}
.container{
  // min-height:100vh;
  // background-color:#313541;
  padding-top:p2r(12px) ;
}
.tabHome {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  // height: p2r(1440px);
  // background-image: url('https://assets.rurushishi.com/yq-rs-make/vcard3/index_bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  padding:0 p2r(30px);
  box-sizing:border-box;
}
.swiper-wrap{
  width: 100%;
}
.myinfo{
  width: 100%;
  padding:0 p2r(40px);
  box-sizing:border-box;
   margin-top: p2r(-50px);
  z-index: 10;
}
.info1-wrap{
  display: flex;
}
.avatar-wrap{
  width: p2r(132px);
  height: p2r(132px);
  border-radius:50%;
  display: flex;
  justify-content :center;
  align-items :center;
  background-color: #fff;
}
.img-avatar{
  width: p2r(110px);
  height: p2r(110px);
  border-radius:50%;
}
.info1-right{
  flex:1;
  display: flex;

}
.audio-wrap{
  height: p2r(44px);
  display: flex;
  justify-content :center;
  align-items :center;
  padding:0 p2r(16px);
  border: p2r(2px) solid #D9AC65;
  border-radius: p2r(10px);
  font-size: p2r(24px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #4B4B4B;
  margin-top: p2r(60px);
  margin-left: 5px;
}
.icon-audio{
  width: p2r(24px);
  height: p2r(24px);
  margin-left :p2r(14px)
}


.info2-wrap{
  display: flex;
  align-items :center;
  margin-top: p2r(5px);
}
.info2-name{
  font-size: p2r(34px);
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
}
.info2-right{
  margin-left: p2r(26px);
}
.info2-right{
  display: flex;
  flex: 1;
  align-items :center;
}
.icon-tel{
  width: p2r(28px);
  height: p2r(28px);
}
.info2-tel{
  font-size: p2r(24px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  margin: 4px;
}
.info3-wrap{
  font-size: p2r(24px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: p2r(34px);
  margin-top:p2r(30px)
}

.btninfo-wrap{
  display: flex;
  justify-content :space-around;
  width: 100%;
  height: p2r(160px);
  background: #F2F3F7;
  border-radius: p2r(8px);
  margin-top: p2r(30px);
}
.btn-item{
  display: flex;
  flex-direction :column;
  justify-content :center;
  align-items :center;
}
.btn-img{
  width: p2r(90px);
  height: p2r(90px);
}
.btn-name{
  font-size: p2r(24px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}


.video-wrap{
  width: 100%
}

.nav-container {
  display: flex;
  padding: p2r(10px) p2r(10px) 0 0;
}

.nav-wrap {
  height: p2r(66px);
  display: flex;
  flex: 1;
  align-items: center;
}

.check-all {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: p2r(24px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

.arrow {
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  width: p2r(12px);
  height: p2r(12px);
  transform: rotate(45deg);
  margin-left: p2r(10px);
  // margin-right: 4px;
}

.active {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
  font-size: p2r(28px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  padding: 0 p2r(10px);
}

.unactive {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: p2r(24px);
  color: #333333;
  // opacity: 0.7;
  padding: 0 p2r(10px);
}

.active::after {
  position: absolute;
  content: '';
  width: p2r(65px);
  height: p2r(4px);
  background: #888888;
  border-radius: 1px;
  bottom: -1px;
  left: p2r(32px);
}

.nav-content {
  overflow: hidden;
  display: flex;
  justify-content :space-between;
  width: 100%;
  // padding: 0 p2r(5px);
  margin-top: p2r(30px);
  box-sizing: border-box;
  overflow-x: scroll;
  box-sizing: border-box;
}

.nav-content::-webkit-scrollbar{
  display :none;
}
.nav-content .item-wrap {
  position:relative;
  display: flex;
  flex: 1;
  justify-content :center;
  align-items :center;
  // flex-direction: column;
  // padding: 0 p2r(10px);
  width: p2r(220px);
}

.cover-img{
  width: 90%;
  height:auto;
}
.cover-img2{
  border-radius:p2r(10px)
}
.video-title{
  position :absolute;
  font-size: p2r(32px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}

.nav-content .item-wrap .item-video {
  display: flex;
  justify-content :center;
  align-items:center;
  position: relative;
  width: p2r(220px);
  height: p2r(220px);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius :p2r(8px)
}



.item-video .times-wrap {
  position: absolute;
  bottom: p2r(10px);
  left: p2r(20px);
  display: flex;
  align-items: center;
}

.bottom-logo-wrap{
  position: relative;
  width: 100%;
  height:auto;
  margin-top: p2r(40px);
  margin-bottom: p2r(40px);
}
.img-logo{
  width: 100%;
  height:auto
}
.pro-wrap{
  display: flex;
  justify-content :center;
  align-items :center;
  height:100%;
  position: absolute;
  top:0;
  right: p2r(40px);
  font-size: p2r(24px);
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
}
.pro-arrow{
  width: p2r(46px);
  height:auto;
  margin-left: p2r(23px);
}
// .times-wrap .triangle {
//   width: 0;
//   height: 0;
//   border-top: p2r(10px) solid transparent;
//   border-bottom: p2r(10px) solid transparent;
//   border-left: p2r(10px) solid #fff;
//   margin-right: p2r(5px);
// }

// .times-text {
//   font-size: p2r(13px);
//   color: #FFFFFF;
// }

// .video-title {
//   width: 100%;
//   text-align: center;
//   margin-top: p2r(10px);
//   font-size: p2r(22px);
//   color: #FFFFFF;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }

// .myinfo-container {
//   display: flex;
//   justify-content: center;
//   width: 100%;
// }

// .myinfo-wrap {
//   width: 94%;
//   // height:p2r(224px)
//   margin-top: p2r(24px);
// }

// .myinfo-wrap .msg-wrap {
//   border-radius: p2r(10px);
//   background-color: #fff;
//   padding: p2r(15px);
//   box-sizing:border-box;
// }

// .usr_info-wrap {
//   display: flex;
//   // align-items: center;
// }

// .msg-wrap .user_info_headimg_wrap {
//   width: p2r(85px);
//   height: p2r(85px);
//   border-radius: 50%;
// }
// .msg-wrap .user_info_headimg {
//   width: 100%;
//   height: 100%;
//   border-radius: 50%;
// }

// .msg-wrap .user_info {
//   margin-left: p2r(21px);
//   flex:1
// }

// .user_info .tel-wrap {
//   display: flex;
//   align-items: center;
//   // margin-top: p2r(10px);
// }

// .tel-wrap .tel-icon {
//   width: p2r(40px);
//   height: p2r(40px);
//   margin-right: p2r(8px);
// }

// .tel-wrap .tel {
// }

// .msg-wrap .usr_intro {
//   margin-top: p2r(10px);
//   line-height :p2r(36px);
//   text-overflow: -o-ellipsis-lastline;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 4;
//   -webkit-box-orient: vertical;
//   box-sizing:border-box;
// }

// .bottom-btn-wrap {
//   display: flex;
//   justify-content: center;
//   position: absolute;
//   bottom: p2r(-50px);
//   left: 0;
//   right: 0;
// }

// .bottom-btn-img {
//   width: p2r(100px);
//   height: p2r(100px);
// }

// .bottom-btn-img.call {
//   margin-right: p2r(6px);
// }

// .bottom-btn-img.wx {
//   margin-left: p2r(6px);
// }
</style>
